import { FiltroGeneracionMasiva } from "../models/filtroGeneracionMasiva"
import * as yup from 'yup'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from "react";
import InputFecha from '../../../../components/inputs/yup/materialui/inputFecha';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import { Grid2 } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import FilterListIcon from '@mui/icons-material/FilterList';
import UseEndosoMasivo from "../../endososMasivos/hooks/useEndosoMasivo";
import Conversiones from "../../../../utils/conversiones";

interface IProps {
    onSubmit: (e: FiltroGeneracionMasiva) => void,
}

export const FormularioFiltroGenMasivo = ({onSubmit} : IProps) => {
    const { defaultValuesGenMasiva, inversionistas, getInversionistas } = UseEndosoMasivo();

    const validationSchema: yup.ObjectSchema<FiltroGeneracionMasiva> = yup.object().shape({
        fechaDesde: yup.date().required("Fecha requerida"),
        fechaOperacion: yup.date().required("Fecha requerida"),
        inversionista: yup.string().required("Inversionista requerido")
    })

    const {
        register,
        formState: { errors, isDirty },
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        control,
        watch,
        trigger
    } = useForm<FiltroGeneracionMasiva>({ resolver: yupResolver(validationSchema), mode: "onChange" })

    useEffect(() => {
        getInversionistas();
    }, [])

    useEffect(() => {
        reset(defaultValuesGenMasiva);
    }, [defaultValuesGenMasiva]);

    return(
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputFecha
                        label="Fecha endoso"
                        name="fechaDesde"
                        control={control}
                        fecha={defaultValuesGenMasiva?.fechaDesde ?? undefined}
                        error={errors.fechaDesde}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputFecha
                        label="Fecha solicitud"
                        name="fechaOperacion"
                        control={control}
                        fecha={defaultValuesGenMasiva?.fechaOperacion ?? undefined}
                        error={errors.fechaOperacion}
                        disabled
                        esReadOnly
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 6 }}>
                    <InputSelect
                        name="inversionista"
                        control={control}
                        options={inversionistas}
                        label="Inversionista"
                        onChange={(value) => setValue("inversionista", value?.toString() ?? "")}
                        error={errors.inversionista}
                    />
                </Grid2>
            </Grid2>
            <Grid2 size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <MButton type="submit" variant="contained" color="primary" startIcon={<FilterListIcon />}>
                    Filtrar
                </MButton>
            </Grid2>
        </form>
    )
}